var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('prompt-variable-textarea');
import TextareaAutosize from 'react-textarea-autosize';
import { classNames, chatValueIsText } from '@shapeable/utils';
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: ", " ", " ", " ", ";\n    justify-content: flex-end;\n    width: 100%;\n    max-width: 500px; \n    box-sizing: border-box;\n    border-radius: ", ";\n    border: 1px solid ", ";\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "], ["\n    background: ", ";\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: ", " ", " ", " ", ";\n    justify-content: flex-end;\n    width: 100%;\n    max-width: 500px; \n    box-sizing: border-box;\n    border-radius: ", ";\n    border: 1px solid ", ";\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "])), theme.COLOR('bright'), theme.UNIT(5, 2), theme.UNIT(2), theme.UNIT(1), theme.UNIT(3), theme.UNIT(2), theme.COLOR('line-subtle'), theme.COLOR('primary'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    overflow: visible;\n    transition: all 0.2s ease-in-out;\n    position: absolute;\n    left: ", ";\n    cursor: text;\n    user-select: none;\n\n    ", "\n  "], ["\n    overflow: visible;\n    transition: all 0.2s ease-in-out;\n    position: absolute;\n    left: ", ";\n    cursor: text;\n    user-select: none;\n\n    ", "\n  "])), theme.UNIT(3), function (_a) {
    var showLabelAbove = _a.showLabelAbove;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n      font-size: ", ";\n      height: ", "px;\n      top: ", "px;\n    "], ["\n      color: ", ";\n      font-size: ", ";\n      height: ", "px;\n      top: ", "px;\n    "])), theme.COLOR('subtle'), theme.FONT_SIZE(showLabelAbove ? 12 : 16), showLabelAbove ? 16 : 20, showLabelAbove ? 6 : 17);
  })
});
var TextAreaStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border: none;\n    outline: none;\n    height: 50px;\n    padding: ", " 0;\n    font-size: 1em;\n    font-family: ", ";\n    color: ", ";\n    background-color: ", ";\n    flex-grow: 1;\n    min-height: 24px;\n\n    background-color: inherit;\n    resize: none;\n\n    ", "\n  "], ["\n    border: none;\n    outline: none;\n    height: 50px;\n    padding: ", " 0;\n    font-size: 1em;\n    font-family: ", ";\n    color: ", ";\n    background-color: ", ";\n    flex-grow: 1;\n    min-height: 24px;\n\n    background-color: inherit;\n    resize: none;\n\n    ", "\n  "])), theme.UNIT(1), theme.FONT('sans'), theme.COLOR('strong'), theme.COLOR('bright'), function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "])), theme.COLOR('text-subtle'), theme.COLOR('subtle'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.label(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  TextArea: styled(TextareaAutosize)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles)
};
export var PromptVariableTextarea = function (props) {
  var className = props.className,
    children = props.children,
    onSubmit = props.onSubmit,
    onChange = props.onChange,
    entity = props.entity,
    disabled = props.disabled,
    isAnother = props.isAnother,
    autoFocus = props.autoFocus,
    title = props.title;
  var value = props.value || '';
  var _a = __read(React.useState(false), 2),
    isFocused = _a[0],
    setIsFocused = _a[1];
  var onFocus = function (e) {
    setIsFocused(true);
  };
  var onBlur = function (e) {
    setIsFocused(false);
  };
  var onKeyDown = function (e) {
    if (onSubmit && e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      onSubmit(value);
    }
  };
  var label = isAnother ? entity.labelAnother || entity.label : entity.label;
  var showLabelAbove = !!(isFocused || value);
  // typeguard ensures this passes checks, and doesn't bomb if accidentally passed an entity
  if (chatValueIsText(value)) {
    return React.createElement(My.Container, {
      title: title,
      className: cls.name(className)
    }, React.createElement(My.Label, {
      htmlFor: entity.id,
      showLabelAbove: showLabelAbove
    }, label), React.createElement(My.TextArea, {
      autoFocus: autoFocus,
      id: entity.id,
      name: entity.name,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      disabled: disabled,
      onChange: function (event) {
        onChange(event.target.value);
      },
      value: value
    }), children);
  }
  return null;
};
PromptVariableTextarea.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;